import { useTkv2NullableOrderContext } from '../../../controller/hooks/useTkv2NullableControllerOrder.ts';
import { selectCompSequence } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

export function useCompSequence() {
  const ctx = useTkv2NullableOrderContext();
  const craftsmanCompSequence = useAppSelector(selectCompSequence);
  return ctx === null ? craftsmanCompSequence : ctx.compSequence;
}
